export const PAGETYPES = {
  CATALOG_PRODUCTS: 'Catalog - Products',
  CATEGORY_TYPE: 'Category - Type',
  CATEGORY_SPECIES: 'Category - Species',
  CATEGORY_DESEASE_FOCUS: 'Category - Disease Focus',
  CATEGORY_APPLICATION: 'Category - Applications',
  CATEGORY_INDUSTRIES: 'Category - Industries',
  SUBCATEGORY_SUBTYPE: 'Subcategory - Subtype',
  SUBCATEGORY_SPECIES: 'Subcategory - Species',
  SUBCATEGORY_DESEASE_FOCUS: 'Subcategory - Disease Focus',
  CATALOG_RESOURCES: 'Catalog - Resources',
  CATEGORY_RESOURCE_ISOLATION_CALENDAR: 'Category - Resource - Isolation Calendar',
  CATEGORY_RESOURCE_POSTERS: 'Category - Resource - Posters',
  CATEGORY_RESOURCE_INTRUCTIONAL_SHEETS: 'Category - Resource - Instructional Sheets',
  CATEGORY_RESOURCE_PROTOCOLS_TUTORIALS: 'Category - Resource - Protocols & Tutorials',
  CATEGORY_RESOURCE_BROCHURES: 'Category - Resource - Brochures',
  CATEGORY_RESOURCE_CASE_STUDIES: 'Category - Resource - Case Studies',
  CATEGORY_RESOURCE_WEBINARS_VIDEOS: 'Category - Resource - Webinars & Videos',
  CATEGORY_RESOURCE_INVENTORY: 'Category - Resource - Ready-to-ship Inventory',
  CATEGORY_RESOURCE_EVENTS: 'Category - Resource - Events',
  CATEGORY_RESOURCE_PRESS_RELEASES: 'Category - Resource - Press Releases',
  CATEGORY_RESOURCE_BLOGS: 'Category - Resource - Blogs',
  CATEGORY_RESOURCE_NEWSLETTER: 'Category - Resource - Newsletter',
  CATEGORY_RESOURCE_PRODUCT_RESOURCES: 'Category - Resource - Product Resources',
  CATEGORY_RESOURCE_ARTICLES: 'Category - Resource - Articles',
  CATEGORY_RESOURCE_EDUCATIONAL_CONTENT: 'Category - Resource - Educational Content',
  CATEGORY_RESOURCE_PRODUCTS: 'Category - Resource - Products',
  CATEGORY_RESOURCE_PUBLICATIONS: 'Category - Resource - Publications',
  LANDING_PAGE: 'Landing Page',
} as const

export const EDUCATIONAL_CONTENT_TYPES = [
  PAGETYPES.CATEGORY_RESOURCE_INTRUCTIONAL_SHEETS,
  PAGETYPES.CATEGORY_RESOURCE_POSTERS,
  PAGETYPES.CATEGORY_RESOURCE_PROTOCOLS_TUTORIALS,
  PAGETYPES.CATEGORY_RESOURCE_BROCHURES,
  PAGETYPES.CATEGORY_RESOURCE_WEBINARS_VIDEOS,
  PAGETYPES.CATEGORY_RESOURCE_CASE_STUDIES,
  PAGETYPES.CATEGORY_RESOURCE_BLOGS,
] as const

export const ROLE_STATUS = {
  COMPANY_ADMIN: 'COMPANY ADMIN',
  DEPARTMENT_MEMBER: 'DEPARTMENT MEMBER',
} as const

export const ROLE_STATUS_TO_LABEL = {
  'COMPANY ADMIN': 'Company Admin',
  'DEPARTMENT MEMBER': 'Department Member',
} as const

export const ROLE_LABEL_TO_STATUS = {
  'Company Admin': 'COMPANY ADMIN',
  'Department Member': 'DEPARTMENT MEMBER',
} as const

export const CURRENCY_OPTIONS = [
  {
    name: 'USD',
    isocode: 'USD',
    symbol: '$',
    active: false,
  },
  {
    name: 'Euro',
    isocode: 'EUR',
    symbol: '€',
    active: false,
  },
  {
    name: 'Pound',
    isocode: 'GBP',
    symbol: '£',
    active: false,
  },
] as const

export const WIDGET_TYPES = {
  textarea: 'textarea',
  qty: 'qty',
  dropList: 'dropList',
  chips: 'chips',
  iconGroup: 'iconGroup',
  cards: 'cards',
} as const

export const PRICE_CODES_TO_TABLE_FIELDS = {
  TVOL: 'volPerLot',
  TADE: 'toggleAliquot',
  TAVO: 'aliquotQty',
  TCEL: 'vialsPerLot',
  TVPE: 'vialsPerDonor',
  TCPV: 'cellQty',
  TOCE: 'customCellsPerLot',
  TOCP: 'customCellQty',
} as const

export const ORDER_TEMPLATE_MODES = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  COPY: 'COPY',
} as const

export const THRESHOLD_TYPES = {
  qty: 'qty',
  ondemand: 'ondemand',
  subscription: 'subscription',
} as const
